import VehicleAdvertisingHtml from './vehicle.advertising.html';

export function VehicleAdvertisingDirective () {
  return {
    controller: 'VehicleAdvertisingCtrl',
    restrict: 'E',
    templateUrl: VehicleAdvertisingHtml,
    scope: {
      advertising: '=',
      settings: '='
    }
  }
}